import { render, staticRenderFns } from "./_promotionWithdrawalSummary.vue?vue&type=template&id=53e0cb2a&scoped=true&lang=pug"
import script from "./_promotionWithdrawalSummary.vue?vue&type=script&lang=js"
export * from "./_promotionWithdrawalSummary.vue?vue&type=script&lang=js"
import style0 from "./_promotionWithdrawalSummary.vue?vue&type=style&index=0&id=53e0cb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e0cb2a",
  null
  
)

export default component.exports